/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type SortDirection = 0 | 1;

export const SortDirection = {
    NUMBER_0: 0 as SortDirection,
    NUMBER_1: 1 as SortDirection
};